module.exports = __webpack_public_path__ + "static/media/yellow_tow.993cd367.png";